import React, { Suspense } from 'react';
import './App.css';
const Navbar = React.lazy(() => import('./components/Navbar/Navbar'));
const Footer = React.lazy(() => import('./components/Footer/Footer'));
const Home = React.lazy(() => import('./components/Home/Home'));
const About = React.lazy(() => import('./components/About/About'));
const OurTeam = React.lazy(() => import('./components/OurTeam/OurTeam'));
const Contact = React.lazy(() => import('./components/Contact/Contact'));

function App() {
  return (<>
    <Suspense fallback={<div>Loading...</div>}>
      <Navbar/>
      <Home/>
      <About/>
      <OurTeam/>
      <Contact/>
      <Footer/>
    </Suspense>
  </>);
}

//Base in https://www.pinterest.com.mx/pin/251638697909601340/

export default App;
